<template>
  <HScaffold :title="itemData[0]+'洗码详情'">
    <div style="background-color: var(--ct-main-bg-color);">
      <HTable :tabData='{
      "header":["游戏场馆", "注单数", "有效投注", "输赢金额", "返水金额"],
      "list": tableList,
      }' :targetMoneyColumnIndex="3"/>
    </div>
  </HScaffold>
</template>


<script setup>
  import HScaffold from "@/components/utils/HScaffold.vue";
  import {useUserStore} from "@/stores/useUser.js";
  import {useHHttp} from "@/hooks/useHHttp.js";
  import {hr} from "@/components/utils/HRouter.js";
  import HTable from "@/components/utils/HTable.vue";

  const user = useUserStore();
  const http = useHHttp();
  const itemData = ref(hr.getRouteParams());
  const tableList = ref([]);

  onMounted(()=>{
    http.request("/app/rebate/statistics/detail", (resp)=>{
      tableList.value = resp["TableList"]??[];
    },{
      params: {
        "DateFormat":itemData.value[0],
      }
    });
  });

</script>


<style scoped>

</style>
